import { getClient as getSharedClient } from "@devforce/trailhead-client-apollo";
import { get as getEnv } from "@devforce/trailhead-client-env";

/**
 * Get the singleton Apollo Client instance for Experience API.
 *
 * IMPORTANT: This returns the shared client from `@devforce/trailhead-client-apollo`
 * so all consumers on the page share a single normalized cache.
 */
export function getClient() {
  const client = getSharedClient();

  // Dev-only sanity check: the package uses a window-global state to avoid duplication
  // when loaded from multiple sources (bundled + `th_component_url`).
  // Trailhead Web sets DEBUG via Rails in `app/views/layouts/_trailhead_client.haml`.
  if (getEnv("DEBUG") && typeof window !== "undefined") {
    const globalState = window["@devforce/trailhead-client-apollo"];
    if (globalState?.client && globalState.client !== client) {
      // eslint-disable-next-line no-console
      console.warn(
        "[experience-api] Detected multiple Apollo client instances. " +
          "This usually indicates @devforce/trailhead-client-apollo was loaded twice " +
          "(bundled + runtime module). Ensure all code uses the shared client."
      );
    }
  }

  return client;
}
